// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0cbe0f91]:export {\n  sideBarWidth: 210px;\n  appHeaderHeight: 60px;\n  interval: 16px;\n}\n.partner-logo[data-v-0cbe0f91] {\n  padding: 24px;\n}\n.partner-logo[data-v-0cbe0f91] .ant-col-5 {\n  width: 20%;\n}\n.partner-logo .img-wrapper[data-v-0cbe0f91] {\n  text-align: center;\n}\n.partner-logo .img-wrapper[data-v-0cbe0f91]:hover {\n  box-shadow: 0 1px 6px 0 hsla(0, 0%, 80%, 0.67);\n}\n.partner-logo .img-wrapper img[data-v-0cbe0f91] {\n  width: 256px;\n}\n", ""]);
// Exports
module.exports = exports;
